var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 1C3.05964 1 2.5 1.55964 2.5 2.25V13.75C2.5 14.4404 3.05964 15 3.75 15H12.25C12.9404 15 13.5 14.4404 13.5 13.75V8.5C13.5 7.11929 12.3807 6 11 6H9.75C9.05964 6 8.5 5.44036 8.5 4.75V3.5C8.5 2.11929 7.38071 1 6 1H3.75Z",
    fill: "#F88634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64746 1.2106C9.17864 1.82432 9.5 2.62463 9.5 3.5V4.75C9.5 4.88807 9.61193 5 9.75 5H11C11.8754 5 12.6757 5.32136 13.2894 5.85254C12.6975 3.58658 10.9134 1.80252 8.64746 1.2106Z",
    fill: "#F88634"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.a77b28079af66954676ef56ee5ad9d7b.svg";
export { ForwardRef as ReactComponent };